/**
 * Bộ biểu tượng PWA — SVG nội tuyến, nét 1.9px, khung 24×24.
 *
 * Nét dày hơn bên trang quản trị (1.9 so với 1.75) là cố ý: PWA dùng ngoài
 * NẮNG, trên màn hình điện thoại cũ có thể đã xước. Nét mảnh biến mất trong
 * điều kiện đó (docs/06 §6.4 — tương phản cao).
 *
 * Trước đây thanh tab dùng ký tự ⏱ ☰ ✎ ☺. Chúng hiển thị KHÁC NHAU trên mỗi
 * hệ điều hành — có máy ra biểu tượng màu, có máy ra ô vuông rỗng — và không
 * chỉnh được kích thước hay độ dày. SVG thì giống nhau ở mọi nơi.
 *
 * Mọi biểu tượng đều `aria-hidden`: chúng đi kèm chữ, không thay chữ.
 */

export type TenIcon =
  | 'dong-ho' | 'lich' | 'soan' | 'nguoi-dung' | 'trai' | 'phai' | 'dong'
  | 'check' | 'canh-bao' | 'thong-tin' | 'khoa' | 'chuong' | 'toan-cau'
  | 'mui-ten-phai' | 'quay-lai' | 'vao' | 'ra' | 'sao' | 'trang' | 'doi-chieu'
  | 'hop-trong' | 'lam-moi' | 'co' | 'banh-sinh-nhat' | 'khien'

const NET: Record<TenIcon, React.ReactNode> = {
  'dong-ho': <><circle cx="12" cy="12" r="9" /><path d="M12 7v5.2l3.2 2" /></>,
  lich: <><rect x="3" y="5" width="18" height="16" rx="2.5" /><path d="M3 10h18M8 3v4M16 3v4" /></>,
  soan: <><path d="M4 20h4.5L19 9.5a2.1 2.1 0 0 0-3-3L5.5 17V20Z" /><path d="M14.5 6.5l3 3" /></>,
  'nguoi-dung': <><circle cx="12" cy="8" r="3.8" /><path d="M4.5 20.5c0-3.7 3.4-6 7.5-6s7.5 2.3 7.5 6" /></>,
  trai: <path d="m14 6-6 6 6 6" />,
  phai: <path d="m10 6 6 6-6 6" />,
  'mui-ten-phai': <path d="m9 5 7 7-7 7" />,
  'quay-lai': <><path d="M20 12H4" /><path d="m10 6-6 6 6 6" /></>,
  dong: <path d="M6 6l12 12M18 6 6 18" />,
  check: <path d="m5 12.5 5 5L19 7" />,
  'canh-bao': <><path d="M12 4 2.8 19.5h18.4Z" /><path d="M12 10v4.2M12 17.2v.1" /></>,
  'thong-tin': <><circle cx="12" cy="12" r="9" /><path d="M12 11v5.5M12 7.8v.1" /></>,
  khoa: <><rect x="4.5" y="10.5" width="15" height="10" rx="2.5" /><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" /></>,
  chuong: <><path d="M6 9a6 6 0 1 1 12 0c0 4 1.5 5.5 1.5 5.5h-15S6 13 6 9Z" /><path d="M10 18a2 2 0 0 0 4 0" /></>,
  'toan-cau': <><circle cx="12" cy="12" r="9" /><path d="M3.2 9.5h17.6M3.2 14.5h17.6" /><path d="M12 3c-2.4 2.4-3.6 5.4-3.6 9s1.2 6.6 3.6 9c2.4-2.4 3.6-5.4 3.6-9S14.4 5.4 12 3Z" /></>,
  vao: <><path d="M14 3.5h4.5a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H14" /><path d="M3.5 12h11" /><path d="m10.5 8 4 4-4 4" /></>,
  ra: <><path d="M10 3.5H5.5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2H10" /><path d="M20.5 12h-11" /><path d="m16.5 8 4 4-4 4" /></>,
  sao: <path d="m12 3.5 2.7 5.6 6.1.85-4.4 4.3 1.05 6.1L12 17.5 6.55 20.35 7.6 14.25 3.2 9.95l6.1-.85Z" />,
  trang: <><path d="M6 3.5h7.5L19 9v11.5H6Z" /><path d="M13 3.5V9h6" /></>,
  'doi-chieu': <><path d="M3.5 8h13l-3-3M20.5 16h-13l3 3" /></>,
  'hop-trong': <><path d="M3.5 9.5 6 4h12l2.5 5.5V19a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 19Z" /><path d="M3.5 9.5h5L10 13h4l1.5-3.5h5" /></>,
  'lam-moi': <><path d="M20 12a8 8 0 1 1-2.6-5.9" /><path d="M20.5 4v4.2h-4.2" /></>,
  co: <><path d="M6 21V4" /><path d="M6 4.5h10.5l-1.8 3.5 1.8 3.5H6" /></>,
  'banh-sinh-nhat': <><path d="M4 20.5h16v-6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2Z" /><path d="M4 16.5c1.6 1.2 3.2 1.2 4.8 0s3.2-1.2 4.8 0 3.2 1.2 4.4 0" /><path d="M8.5 12.5V9.5M12 12.5V9.5M15.5 12.5V9.5" /><path d="M8.5 6.8v.1M12 6.3v.1M15.5 6.8v.1" /></>,
  khien: <><path d="M12 3l7.5 3v5.5c0 4.6-3.1 8.2-7.5 9.5-4.4-1.3-7.5-4.9-7.5-9.5V6Z" /><path d="m9 12 2 2 4-4" /></>,
}

export default function Icon(
  { ten, size = 20, className }: { ten: TenIcon; size?: number; className?: string },
) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {NET[ten]}
    </svg>
  )
}
